  // Overlay functionality
  document.addEventListener('DOMContentLoaded', function() {
    const navButtons = document.querySelectorAll('.vijn-nav-btn[data-overlay]');
    const closeButtons = document.querySelectorAll('.vijn-overlay-close');
    const overlays = document.querySelectorAll('.vijn-overlay');

    navButtons.forEach(button => {
      button.addEventListener('click', function() {
        const overlayId = this.getAttribute('data-overlay');
        const overlay = document.getElementById(`vijn-${overlayId}-overlay`);
        if (overlay) {
          overlay.classList.add('vijn-active');
          document.body.style.overflow = 'hidden';
        }
      });
    });

    closeButtons.forEach(button => {
      button.addEventListener('click', function() {
        const overlayId = this.getAttribute('data-close');
        const overlay = document.getElementById(`vijn-${overlayId}-overlay`);
        if (overlay) {
          overlay.classList.remove('vijn-active');
          document.body.style.overflow = '';
        }
      });
    });

    // Close overlay on background click
    overlays.forEach(overlay => {
      overlay.addEventListener('click', function(e) {
        if (e.target === this) {
          this.classList.remove('vijn-active');
          document.body.style.overflow = '';
        }
      });
    });

    // Close overlay on Escape key
    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') {
        overlays.forEach(overlay => {
          overlay.classList.remove('vijn-active');
        });
        document.body.style.overflow = '';
      }
    });
  });